import data from './data'
import components from './components'

export default {
  data,
  components
}



// WEBPACK FOOTER //
// ./src/app/profile-public/professional/resources/index.js